import { local_storage_utils } from './frfr-webstorage-utils';

/*
FRONTEND DB STORAGE adapter
Omogucuje da se frontend db kod moze koristiti i sa drugim engineima koji nisu local storage od browsera. Na primer da bi mogli da ga koristimo za neki drugi engine na NODEJS.
*/


// CONFIGURE storage for frontend db
let browser_local_storage = true; // use browser local storage as storage engine
// let nodejs_storage_engine = false; // use some custom NODEJS storage...


const fdb_storage_adapter = {};

fdb_storage_adapter.get = async (key) => {
  if (browser_local_storage) {
    // browser
    let raw = await local_storage_utils.item_get(key);
    return raw;
  } else {
    // NODEJS storage engine

  }
}

fdb_storage_adapter.set = async (key, data) => {
  if (browser_local_storage) {
    // browser
    await local_storage_utils.item_set(key, data);
    return true;
  } else {
    // NODEJS storage engine

  }
}

fdb_storage_adapter.delete = async (key) => {
  if (browser_local_storage) {
    // browser
    await local_storage_utils.item_delete(key); // delete from localstorage
    return true;
  } else {
    // NODEJS storage engine

  }
}

export default fdb_storage_adapter;
// module.exports = fdb_storage_adapter; // Node.js export default